import { fetchPersea } from "@/config/axios/config-axios";
import { Mission } from "@/types/mission/mission-type";
import { Objective } from "@/types/objective/objective-type";
import { ALLOWED_OBJECTIVE_REQUIREMENTS } from "@/components/missions-render-v1/components/requirements-objective/utils";


export const getMissionCustom = async (params = {}) => {
    return await fetchPersea(`/campaign/mission`, 'GET', params);
};

export const getMissionSurvey = async (params: { id: number }) => {
    if (!params.id) {
        throw new Error('id is required');
    }
    return await fetchPersea(`/survey/schema`, 'GET', params);
};


export const saveMissionSurvey = async (body = {}) => {
    return await fetchPersea(`/survey/result`, 'POST', {}, body);
};

export const getMissionProgress = async ({ user_main_key, mission_id }: { 
    user_main_key: string | undefined, 
    mission_id: number 
}) => {

    if (!user_main_key) {
        return [];
    }

    const result = await fetchPersea('/campaign/mission/progress', 'GET', {
        mission_id,
        user_main_key
    });
    return result;
};


export const getMissionCustomWithFormatObjective = async (params ={}) => {
    const missions = await fetchPersea(`/campaign/mission`, 'GET', params);
    const allRequirements: Objective[] = [];
    const allMissions: Mission[] = [];
    const uniqueTypes = new Set<string>();

    missions.forEach((mission: Mission) => {
        const requirements = mission.objectives.filter((objective: Objective) => {
            const newType = objective.type.split(':')[0];
            if (ALLOWED_OBJECTIVE_REQUIREMENTS.includes(newType) && !uniqueTypes.has(objective.type)) {
                uniqueTypes.add(objective.type);
                return true;
            }
            return false;
        });
        allRequirements.push(...requirements);
    });

    missions.forEach((mission: Mission) => {
        const missions = mission.objectives.filter((objective: Objective) => {
            const newType = objective.type.split(':')[0];
            return !ALLOWED_OBJECTIVE_REQUIREMENTS.includes(newType);
        });
        allMissions.push({
            ...mission,
            objectives: missions
        });
    });
    return { allMissions, allRequirements };
};

export const getInfoObjectiveRank = async (params = {}) => {
    return await fetchPersea(`/campaign/mission/objective/rank`, 'GET', params);
};